import { axiosClient } from "@lib/services/axios";
import { ENDPOINTS } from "@lib/constants/general";
import { UnitList } from "@lib/types/units";
import { DriversList } from "@lib/types/driver";

export const getUnits = async (): Promise<UnitList> => {
  const { data } = await axiosClient.get(ENDPOINTS.BASE_UNITS);
  return data;
};

export const getUnitDetails = async (unitId: number): Promise<DriversList> => {
  const { data } = await axiosClient.get(
    ENDPOINTS.BASE_UNITS + "/" + unitId + "/drivers"
  );
  return data;
};
